import type { Option } from "~/modules/globalDeviceConfiguration/models/Option.interface";

/**
 * Add an option to an option list.
 * If an option with the same value already exist, it is not added unless parameter "replace" is true.
 * @param newOption
 * @param options
 * @param replace
 */
export function addOption(
  newOption: Option,
  options: Option[],
  replace: boolean = false,
): Option[] {
  const index = options.findIndex((option) => option.value === newOption.value);

  if (index === -1) {
    options.push(newOption);
    options.sort((option1, option2) => option1.value - option2.value);
  } else if (replace) {
    options.splice(index, 1, newOption);
  }

  return options;
}
